import React, { useMemo, useState } from "react";
import { FaEdit, FaUsers, FaClipboardList, FaMedkit, FaUserShield, FaStar, FaSearch, FaTable, FaDiscord } from "react-icons/fa";
import PreviewPopup from "./PreviewPopup";

const TripDetailsActions = ({
  onEditClick,
  onRegistrationsClick,
  onAttendanceClick,
  onDiscordClick,
  onAccessClick,
  onInsuranceClick,
  onPriorityClick,
  onSummaryClick,
  onMarkReadyForSettlement,
  tripGuid,
  tripSettlementStatus,
  hasExplicitAccess,
  mode = "secondary",
}) => {
  const baseUrl = process.env.REACT_APP_TRIPS_BASE;
  const [previewOpen, setPreviewOpen] = useState(false);

  const previewUrl = useMemo(() => {
    if (!baseUrl || !tripGuid) return "";
    return `${baseUrl}/${tripGuid}`;
  }, [baseUrl, tripGuid]);

  const headerActions = [
    { key: "edit", label: "Edytuj wycieczkę", icon: <FaEdit className="trip-details-button-icon" />, onClick: onEditClick, requiresExplicit: true },
    { key: "priority", label: "Link do zapisów priorytetowych", icon: <FaStar className="trip-details-button-icon" />, onClick: onPriorityClick, requiresExplicit: true },
    { key: "preview", label: "Podgląd wycieczki", icon: <FaSearch className="trip-details-button-icon" />, onClick: () => setPreviewOpen(true), requiresExplicit: false },
    ...(tripSettlementStatus === 1 ? [{ key: "readyForSettlement", label: "Zgłoś do rozliczenia", icon: <i className="fa-solid fa-file-circle-check trip-details-button-icon" />, onClick: onMarkReadyForSettlement, requiresExplicit: true }] : []),
  ];

  const variantHeaderActions = [
    { key: "edit", label: "Edytuj wycieczkę", icon: <FaEdit className="trip-details-button-icon" />, onClick: onEditClick, requiresExplicit: true },
    { key: "preview", label: "Podgląd wycieczki", icon: <FaSearch className="trip-details-button-icon" />, onClick: () => setPreviewOpen(true), requiresExplicit: false },
  ];

  const quickActions = [
    { key: "edit", label: "Edytuj wycieczkę", icon: <FaEdit className="trip-details-button-icon" />, onClick: onEditClick, requiresExplicit: true },
    { key: "priority", label: "Link do zapisów priorytetowych", icon: <FaStar className="trip-details-button-icon" />, onClick: onPriorityClick, requiresExplicit: true },
  ];

  const secondaryActions = [
    { key: "insurance", label: "Ubezp. tur.", icon: <FaMedkit className="trip-details-button-icon" />, onClick: onInsuranceClick, requiresExplicit: true },
    { key: "access", label: "Dostęp", icon: <FaUserShield className="trip-details-button-icon" />, onClick: onAccessClick, requiresExplicit: true },
    { key: "preview", label: "Podgląd", icon: <FaSearch className="trip-details-button-icon" />, onClick: () => setPreviewOpen(true), requiresExplicit: false },
    ...(tripSettlementStatus === 1 ? [{ key: "readyForSettlement", label: "Zgłoś do rozl.", icon: <i className="fa-solid fa-file-circle-check trip-details-button-icon" />, onClick: onMarkReadyForSettlement, requiresExplicit: true }] : []),
    { key: "summary", label: "Zestawienia", icon: <FaTable className="trip-details-button-icon" />, onClick: onSummaryClick, requiresExplicit: false },
  ];

  const mobileActions = [
    { key: "edit", label: "Edytuj", icon: <FaEdit className="trip-details-button-icon" />, onClick: onEditClick, requiresExplicit: true },
    { key: "registrations", label: "Rejestracje", icon: <FaClipboardList className="trip-details-button-icon" />, onClick: onRegistrationsClick, requiresExplicit: false },
    { key: "people", label: "Osoby", icon: <FaUsers className="trip-details-button-icon" />, onClick: onAttendanceClick, requiresExplicit: true },
    { key: "discord", label: "Discord", icon: <FaDiscord className="trip-details-button-icon" />, onClick: onDiscordClick, requiresExplicit: true },
    { key: "insurance", label: "Ubezp. tur.", icon: <FaMedkit className="trip-details-button-icon" />, onClick: onInsuranceClick, requiresExplicit: true },
    { key: "access", label: "Dostęp", icon: <FaUserShield className="trip-details-button-icon" />, onClick: onAccessClick, requiresExplicit: true },
    { key: "preview", label: "Podgląd", icon: <FaSearch className="trip-details-button-icon" />, onClick: () => setPreviewOpen(true), requiresExplicit: false },
    { key: "priority", label: "Zapisy priorytetowe", icon: <FaStar className="trip-details-button-icon" />, onClick: onPriorityClick, requiresExplicit: true },
    ...(tripSettlementStatus === 1 ? [{ key: "readyForSettlement", label: "Zgłoś do rozl.", icon: <i className="fa-solid fa-file-circle-check trip-details-button-icon" />, onClick: onMarkReadyForSettlement, requiresExplicit: true }] : []),
    { key: "summary", label: "Zestawienia", icon: <FaTable className="trip-details-button-icon" />, onClick: onSummaryClick, requiresExplicit: false },
  ];

  const source = mode === "variantHeader" ? variantHeaderActions : mode === "header" ? headerActions : mode === "quick" ? quickActions : mode === "mobile" ? mobileActions : secondaryActions;
  const visibleActions = source.filter(a => !a.requiresExplicit || hasExplicitAccess);
  const compactHeader = mode === "header" || mode === "variantHeader";

  return (
    <>
      <div className={`trip-details-buttons trip-details-buttons--${mode}`}>
        {visibleActions.map((a, index) => (
          <button type="button" key={a.key} className={`trip-details-button-container ${mode === "quick" && index === 0 ? "trip-details-button-container--primary" : ""}`} onClick={a.onClick}>
            <span className="trip-details-button">{a.icon}</span>
            <span className="trip-details-button-label">{a.label}</span>
          </button>
        ))}
      </div>
      {previewOpen && <PreviewPopup url={previewUrl} title="Podgląd wycieczki" onClose={() => setPreviewOpen(false)} />}
    </>
  );
};

export default TripDetailsActions;
